// extracted by mini-css-extract-plugin
export default {"TemplateSearch":"_TemplateSearch--I3v7k","TemplateSearchDisabled":"_TemplateSearchDisabled--OrKAo"};